import React, { useState } from 'react';
import { Send, Stethoscope } from 'lucide-react';
import { useSessionStore } from '../../store/sessionStore';

export const DoctorInput: React.FC = () => {
  const [input, setInput] = useState('');
  const { addMessage } = useSessionStore();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input.trim()) {
      addMessage({ sender: 'doctor', text: input.trim() });
      setInput('');
    }
  };

  const canSend = input.trim().length > 0;

  return (
    <form onSubmit={handleSubmit} className="flex gap-2 items-center">
      <div
        className="flex-1 flex items-center gap-2 px-3 py-1 rounded-2xl transition-all"
        style={{
          background: 'rgba(13,23,48,0.7)',
          border: `1px solid ${canSend ? 'rgba(14,165,233,0.3)' : 'rgba(255,255,255,0.07)'}`,
          backdropFilter: 'blur(12px)',
          boxShadow: canSend ? '0 0 0 1px rgba(14,165,233,0.1)' : 'none',
        }}
      >
        <Stethoscope className="w-4 h-4 flex-shrink-0" style={{ color: 'rgba(148,163,184,0.4)' }} />
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Médico digita a resposta aqui..."
          className="flex-1 py-2.5 bg-transparent text-sm text-white outline-none"
          style={{
            caretColor: '#38bdf8',
          }}
        />
      </div>

      <button
        type="submit"
        disabled={!canSend}
        className="w-11 h-11 rounded-2xl flex items-center justify-center flex-shrink-0 transition-all active:scale-95"
        style={canSend ? {
          background: 'linear-gradient(135deg, #0ea5e9, #14b8a6)',
          boxShadow: '0 4px 16px rgba(14,165,233,0.3)',
          border: 'none',
        } : {
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.07)',
        }}
      >
        <Send
          className="w-4 h-4"
          style={{ color: canSend ? 'white' : 'rgba(100,116,139,0.5)' }}
        />
      </button>
    </form>
  );
};
